module.exports = __webpack_public_path__ + "img/product-sm-1.cb3d7715.png";